import { render, staticRenderFns } from "./SettingIgnoreMyAge.vue?vue&type=template&id=74721d59&"
import script from "./SettingIgnoreMyAge.vue?vue&type=script&lang=js&"
export * from "./SettingIgnoreMyAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports